module.exports = __webpack_public_path__ + "img/bannerC.82b32384.jpg";